import { render, staticRenderFns } from "./user-whitelist.vue?vue&type=template&id=0ba253e4&scoped=true"
import script from "./user-whitelist.vue?vue&type=script&lang=js"
export * from "./user-whitelist.vue?vue&type=script&lang=js"
import style0 from "./user-whitelist.vue?vue&type=style&index=0&id=0ba253e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba253e4",
  null
  
)

export default component.exports